import { render, staticRenderFns } from "./EcpmsTable.vue?vue&type=template&id=70dd6e28&"
import script from "./EcpmsTable.vue?vue&type=script&lang=js&"
export * from "./EcpmsTable.vue?vue&type=script&lang=js&"
import style0 from "./EcpmsTable.vue?vue&type=style&index=0&id=70dd6e28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports